module.exports = __webpack_public_path__ + "img/Peritêcio 2.b8300793.webp";